import { BaseError } from '@d-id/studio/src/errors/base.error';

export enum TranslationStatus {
    Created = 'created',
    Validating = 'validating',
    Done = 'done',
    Ready = 'ready',
    Error = 'error',
    Started = 'started',
    Rejected = 'rejected',
    Uploading = 'uploading',
    Draft = 'draft',
}

export interface ITranslation {
    id: string;
    name: string;
    owner_id: string;
    source_url: string;
    audio_url?: string;
    subtitles_url?: string;
    result_url?: string;
    created_at: string;
    generated_at?: string;
    modified_at: string;
    created_by: string;
    status: TranslationStatus;
    error?: BaseError;
    duration?: number;
    persist?: boolean;
    voice_id?: string;
    custom_voice_id?: string;
    subtitles: boolean;
    avatar_id?: string;
    video_id?: string;
    script?: string;
    group_id: string;
    language: string;
    locale: string;
    proofreading?: boolean;
    thumbnail_url?: string;
    transcriptions?: Transcription[];
}

interface Transcription {
    url: string;
    version: 'original' | 'shortened' | 'edit';
    selected?: boolean;
}

export const SUPPORTED_LANGUAGES: Record<string, string> = {
    chinese: 'zh-CN',
    korean: 'ko-KR',
    dutch: 'nl-NL',
    turkish: 'tr-TR',
    swedish: 'sv-SE',
    indonesian: 'id-ID',
    filipino: 'fil-PH',
    japanese: 'ja-JP',
    ukrainian: 'uk-UA',
    greek: 'el-GR',
    czech: 'cs-CZ',
    finnish: 'fi-FI',
    romanian: 'ro-RO',
    russian: 'ru-RU',
    danish: 'da-DK',
    bulgarian: 'bg-BG',
    malay: 'ms-MY',
    slovak: 'sk-SK',
    croatian: 'hr-HR',
    arabic: 'ar-SA',
    tamil: 'ta-IN',
    english: 'en-US',
    polish: 'pl-PL',
    german: 'de-DE',
    spanish: 'es-ES',
    french: 'fr-FR',
    italian: 'it-IT',
    hindi: 'hi-IN',
    portuguese: 'pt-PT',
};

export type Caption = { start: number; end: number; text: string };

export type CaptionsData = {
    language: string;
    originText: string;
    sentences: Caption[];
    words: any[];
};
